import { render } from "./AddClientSubscription.vue?vue&type=template&id=238a96af"
import script from "./AddClientSubscription.vue?vue&type=script&lang=js"
export * from "./AddClientSubscription.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__